import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Notice from './Notice';
import Group from '../Group/Group';

const onClick = e => e.preventDefault();

class NoticeExample extends Component {

  state = {
    successMessage: (
      <span>
        You can't climb the <a href="#!" onClick={onClick}>ladder of success</a> with your hands in your pockets.
      </span>
    ),
  };

  onChange = e => this.setState(e.target.value);

  onClear = e => window.showAppInfo('Message cleared');

  render() {
    return (
      <Example {...this.props}>
        <Properties
          onChange={this.onChange}
          defaultProps={Notice.defaultProps}
          propTypes={Notice.propTypes}
          propValues={this.state}/>
        <Group>
          <Notice {...this.state} onClear={this.onClear}/>
          <Notice infoMessage="I know what you are thinking. Did he fire five shots or six?" onClear={this.onClear} />
          <Notice warningMessage="With all the commotion I'm not sure myself. So you have to ask yourself a question: 'Do I feel lucky?'"  onClear={this.onClear}/>
          <Notice errorMessage="I'm sorry Dave. I can't let you do that." onClear={this.onClear} />
        </Group>
        <SourceCode querySelector=".notice-example .core-notice"/>
      </Example>
    );
  }

}

NoticeExample.tags = 'message error info success warning';

export default NoticeExample;